export default function convertWebsitesToOptions(websites) {
  return websites.map((website) => ({
    label: website.url,
    value: website.uuid,
    website,
  }))
}
